import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export function HeroSection() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center"
    >
      <span className="inline-flex items-center gap-2 rounded-full border border-border bg-secondary/60 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
        <Sparkles size={13} className="neon-magenta" /> One tap, whole night
      </span>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">
        Plan the perfect
        <br />
        <span className="text-cta-gradient">night out</span>
      </h1>
      <p className="mt-4 text-base sm:text-lg text-muted-foreground max-w-xl mx-auto">
        Dinner, a live event, and drinks after — all real venues, mapped and timed,
        picked to match your vibe.
      </p>
    </motion.div>
  );
}
